@if (type() === 'image' && imageSrc) {
  <img #image [src]="imageSrc" [ngStyle]="imageStyles()" (error)="imageError.emit($event)" />
} @else if (type() === 'image-with-container' && imageSrc) {
  <div
    class="image-container"
    [ngStyle]="imageStyles()"
    [style.background-image]="'url(' + imageSrc + ')'"
  ></div>
} @else if (type() === 'initials' && nameInitials) {
  <div
    #avatarPlaceholder
    class="avatar-placeholder"
    [class.is-candidate]="context() === 'candidate'"
    [class.is-admin]="context() === 'admin'"
    [class.is-other]="context() === 'other'"
    [class.font-size-backend-style]="fontSize() === 'small'"
    [class.colorized]="isColorized()"
  >
    <div class="initials">{{ nameInitials }}</div>
  </div>
} @else if (type() === 'icon' && iconName) {
  <div
    #avatarIconWrapper
    class="avatar-icon"
    [class.is-candidate]="context() === 'candidate'"
    [class.is-other]="context() === 'other'"
  >
    <rt-icon [name]="iconName" [size]="customIconSize() || iconSize" [colorToken]="iconColor()" />
  </div>
} @else if (type() === 'custom' && avatarTpl) {
  <ng-container *ngTemplateOutlet="avatarTpl!" />
}

@if (isOnline()) {
  <div class="online-indicator"></div>
}

@if (rsvpBadge) {
  @switch (rsvpBadge) {
    @case (AvatarRsvpBadge.Accepted) {
      <div class="rsvp-badge accepted">
        <rt-icon size="small-xx" colorToken="colorIconOnsuccessDefault" name="check-small" />
      </div>
    }
    @case (AvatarRsvpBadge.Declined) {
      <div class="rsvp-badge declined">
        <rt-icon size="small-xx" colorToken="colorIconOncriticalDefault" name="close-small" />
      </div>
    }
    @case (AvatarRsvpBadge.Tentative) {
      <div class="rsvp-badge tentative">
        <rt-icon size="small-xx" colorToken="colorIconOnwarningDefault" name="help-plain" />
      </div>
    }
  }
}

@if (hasUnreadNotifications()) {
  <div class="has-notifications">
    <ng-container *ngTemplateOutlet="tooltipTplRef()" />
  </div>
}
